export const TR = {
    adminCoursesTableBox_noResults: 'Es konnten keine Einträge gefunden werden.',
    adminCoursesTableBox_translations: {
        continuous: 'Fortlaufender Kurs',
        ondemand: 'Kurs auf Anfrage',
        selflearn: 'Selbstlernkurs',
        set: 'Kurs mit Terminsets',
        single: 'Kurs mit Einzelterminen',
    },
    adminCoursesTableBox_published: 'Veröffentlichter Kurs',
    adminCoursesTableBox_draft: 'Nicht veröffentlicht /Entwurf',
    adminCoursesTableBox_block: 'Kurs sperren',
    adminCoursesTableBox_unblock: 'Sperre aufheben',
    adminCoursesTableBox_showLess: 'Weniger anzeigen',
    adminCoursesTableBox_showMore: 'Mehr anzeigen',
    adminCoursesTableBox_appointments: 'Termine',
    adminCoursesTableBox_startDate: 'Startdatum',
    adminCoursesTableBox_endDate: 'Enddatum',
    adminCoursesTableBox_places: 'Anzahl Plätze zur Vermittlung',
    adminCoursesTableBox_booking_request: 'Buchungsanfragen',
    calendar_cancel: 'abbrechen',
    calendar_add: 'hinzufügen',
    tableBoxForCPBookingsNew_no_entries_found: 'Es konnten keine Einträge gefunden werden.',
    tableBoxForCPBookingsNew_reason: 'Grund:',
    tableBoxForCPBookingsProofed_no_results: 'Es konnten keine Einträge gefunden werden.',
    tableBoxForCPBookingsProofed_name: 'Name',
    tableBoxForCPBookingsProofed_address: 'Adresse',
    tableBoxForCPBookingsProofed_telephone: 'Telefon',
    tableBoxForCPBookingsProofed_email: 'E-Mail',
    tableBoxForCPBookingsProofed_not_confirmed: 'Nicht durch Kursanbieter bestätigt. Grund :',
    tableBoxForNewParticipant_course: 'Kurs',
    tableBoxForNewParticipant_appointment: 'Termin',
    tableBoxForNewParticipant_bookingoption: 'Buchungsoption',
    tableBoxForNewParticipant_course_price: 'Kursgebühr',
    tableBoxForNewParticipant_first_name: 'Vorname',
    tableBoxForNewParticipant_last_name: 'Nachname',
    tableBoxForNewParticipant_telephone: 'Telefon',
    tableBoxForNewParticipant_email: 'E-Mail',
    tableBoxForNewParticipant_enter_bookings:
        'Bitte trage hier direkt bei dir eingegangene und abrechnungsrelevante Buchungen im Sinne unserer AGB ein.',
    tableBoxForNewParticipant_save: 'speichern',
    cPCoursesTableBox_no_results: 'Es konnten keine Einträge gefunden werden.',
    cPCoursesTableBox_published_course: 'Veröffentlichter Kurs',
    cPCoursesTableBox_not_published: 'Nicht veröffentlicht /Entwurf',
    cPCoursesTableBox_course_blocked_by_admin: 'Dein Kurs wurde durch den Admin gesperrt',
    cPCoursesTableBox_appointments: 'Termine',
    cPCoursesTableBox_request: ' Anfrage)',
    cPCoursesTableBox_requests: ' Anfragen)',
    cPCoursesTableBox_start_date: 'Startdatum',
    cPCoursesTableBox_end_date: 'Enddatum',
    cPCoursesTableBox_number_places: 'Anzahl Plätze zur Vermittlung',
    cPCoursesTableBox_booking_requests: 'Buchungsanfragen',
    cPCoursesTableBox_booking_options: 'Buchungsoptionen:',
    cPHeaderLoggedIn_courses: 'Kurse',
    cPHeaderLoggedIn_edit_course: 'Kurs bearbeiten',
    cPHeaderLoggedIn_teachers: 'Dozent:innen',
    cPHeaderLoggedIn_locations: 'Veranstaltungsorte',
    cPHeaderLoggedIn_bookings: 'Buchungsanfragen',
    cPHeaderLoggedIn_profile: 'Profil',
    cPLecturerComponent_salutation: 'Anrede',
    cPLecturerComponent_title: 'Titel',
    cPLecturerComponent_first_name: 'Vorname',
    cPLecturerComponent_last_name: 'Nachname',
    cPLecturerComponent_description: 'Beschreibung / Vita (optional)',
    cPLecturerComponent_lecturer_website: 'Dozenten Website',
    cPLecturerComponent_cancel: 'Abbrechen',
    cPLecturerComponent_save: 'Speichern',
    cPLecturerList_lecturers: 'Dozent:innen',
    cPLecturerList_add_lecturer: 'Neue Dozent:innen hinzufügen',
    cPLocationComponent_location_name: 'Name des Veranstaltungsorts',
    cPLocationComponent_telephone: 'Telefonnummer (optional)',
    cPLocationComponent_street: 'Straße + Hausnr.',
    cPLocationComponent_postal_code: 'PLZ',
    cPLocationComponent_city: 'Ort',
    cPLocationComponent_country: 'Land',
    cPLocationComponent_nothing_special: 'Keine Besonderheiten hinzugefügt.',
    cPLocationComponent_name_location: 'Name des Veranstaltungsorts',
    cPLocationComponent_street_housenr: 'Straße + Hausnr.',
    cPLocationComponent_show_on_map: 'In Karte anzeigen',
    cPLocationComponent_upload_images: 'Lade hier Bilder hoch',
    cPLocationComponent_specialties: 'Besonderheiten',
    cPLocationList_locations: 'Veranstaltungsorte',
    cPLocationList_add_location: 'Weiteren Veranstaltungsort hinzufügen',
    cPAccount_enter_valid_email: 'Bitte gebe eine gültige E-mail ein.\n',
    cPAccount_email_min_length: 'Die E-mail muss mindestens 5 Zeichen lang sein.\n',
    cPAccount_password_min_length: 'Dein Passwort muss mindestens 6 Zeichen lang sein.\n',
    cPAccount_email_exists: 'Diese E-Mail ist bereits vergeben.',
    cPAccount_email: 'E-Mail:',
    cPAccount_password: 'Passwort:',
    cPAccount_password_mismatch: 'Deine Eingaben sind nicht identisch. Bitte überprüfe die Eingaben.',
    cPAccount_change_email: 'E-Mail ändern',
    cPAccount_enter_new_email: 'Neue E-Mail eingeben:',
    cPAccount_repeat_email: 'Neue E-Mail bestätigen:',
    cPAccount_enter_new_password: 'Neues Passwort eingeben:',
    cPAccount_repeat_new_password: 'Neues Passwort bestätigen:',
    cPAdress_check_data: 'Bitte prüfe deine Eingaben',
    cPAdress_missing_entry: '"Es fehlt noch deine Angabe, bitte ausfüllen."',
    cPAdress_company_name: 'Firmenname:',
    cPAdress_company_address: 'Firmenadresse:',
    cPAdress_different_invoice_address: 'Abweichende Rechnungsanschrift:',
    cPAdress_invoice_recipient: 'Rechnungsempfänger:',
    cPAdress_invoice_address: 'Rechnungsadresse:',
    cPAdress_company_name2: 'Firmenname',
    cPAdress_postal_code: 'PLZ',
    cPAdress_city: 'Ort',
    cPAdress_country: 'Land',
    cPAdress_different_address: 'Abweichende Rechnungsanschrift',
    cPAdress_company_name3: 'Firmenname (optional)',
    cPAdress_first_name: 'Vorname',
    cPAdress_last_name: 'Nachname',
    cPAdress_street_house_number: 'Straße + Hausnr.',
    cPAdress_enter_address: 'Gib hier deine Anschrift und ggf. eine abweichende Rechnungsadresse ein.',
    cPBaseData_missing_data: '"Es fehlt noch deine Angabe, bitte ausfüllen."',
    cPBaseData_fill_one_field: 'Bitte wähle mindesten ein Feld aus',
    cPBookingTerms_check_data: 'Bitte prüfe deine Eingaben',
    cPBookingTerms_missing_data: '"Es fehlt noch deine Angabe, bitte ausfüllen."',
    cPBookingTerms_booking_terms_line1: 'Anzahlung xx% nach bestätigter Buchung\n',
    cPBookingTerms_booking_terms_line2:
        'Storno bis n Tage vor Kursbeginn, gratis, danach xx% der ausgewiesenen Kursgebühr\n',
    cPBookingTerms_booking_terms_line3: 'Zahlung per Überweisung oder bar vor Ort möglich\n',
    cPBookingTerms_booking_terms: 'Buchungsbedingungen',
    cPBookingTerms_template: 'Standardvorlage einfügen',
    cPBookingTerms_agb_text:
        'Hinterlege hier deine AGB als Link oder Freitext. Wenn du noch keine AGB hast, kannst du mit unserer Standardvorlage starten und sie an deine Bedürfnisse anpassen. Diese Angabe ist auf kukundo sichtbar.',
    cPBookingTerms_example_agbs:
        'Wir haben beispielhafte Buchungsbedingungen in das Eingabefeld eingefügt. Bitte passe diese entsprechend an. Du kannst auch in dem Bereich abbrechen drücken um den vorherigen Wert zu behalten.\n',
    cPBookingTerms_added_template: 'Standardvorlage eingefügt',
    cPBookingTerms_ok: 'Ok',
    cPContactingFromWhere_connection: 'Wie bist du auf uns aufmerksam geworden?',
    cPContactingFromWhere_check_data: 'Bitte prüfe deine Eingaben',
    cPContactingFromWhere_please_choose: 'Bitte Auswählen',
    cPContactingFromWhere_google: 'Google Suche',
    cPContactingFromWhere_instagram: 'Instagram',
    cPContactingFromWhere_friends: 'Empfehlung durch Freunde oder Bekannte',
    cPContactingFromWhere_flyer: 'Flyer',
    cPContactingFromWhere_ads: 'Werbung',
    cPContactingFromWhere_other: 'Sonstiges',
    cPContactingFromWhere_save: 'Speichern',
    cPInvoiceData_missing_data: 'Es fehlt noch deine Angabe, bitte ausfüllen.',
    cPInvoiceData_modalities: ' Modalitäten:',
    cPInvoiceData_vat_yes: 'umsatzsteuerpflichtig',
    cPInvoiceData_vat_no: 'umsatzsteuerbefreit',
    cPInvoiceData_commision_fee: 'Vermittlungsgebühr:',
    cPInvoiceData_I_am: 'Als Kursanbieter:in bin ich:',
    cPInvoiceData_not_visible:
        'Diese Angabe ist auf kukundo NICHT sichtbar. Sie dient uns zur korrekten Rechnungsstellung.',
    cPInvoiceData_invoicing_terms: 'Rechnungsmodalitäten',
    cPItemEditComponent_cancel: 'Abbrechen',
    cPItemEditComponent_save: 'Speichern',
    cPName_name_org: 'Name Atelier/Kunstschule/Künstler:in',
    cPName_check_data: 'Bitte prüfe deine Eingaben',
    cPName_fill_out: 'Es fehlt noch deine Angabe, bitte ausfüllen.',
    cPName_your_name: 'Unter diesem Namen bist du auf kukundo.de sichtbar',
    cPPersonalData_contact_person: 'Ansprechpartner:in',
    cPPersonalData_check_data: 'Bitte prüfe deine Eingaben',
    cPPersonalData_please_fill: 'Es fehlt noch deine Angabe, bitte ausfüllen.',
    cPPersonalData_name: 'Name:',
    cPPersonalData_contact: 'Kontakt:',
    cPPersonalData_website: 'Website:',
    cPPersonalData_salutation: 'Anrede',
    cPPersonalData_first_name: 'Vorname',
    cPPersonalData_last_name: 'Nachname',
    cPPersonalData_email: 'E-Mail',
    cPPersonalData_telephone: 'Telefon (optional)',
    cPPersonalData_website2: 'Website',
    cPPersonalData_main_contact:
        'Gib hier den/die Hauptansprechpartner:in ein. Dieser Kontakt ist auf deinem Profil für die Besucher sichtbar.',
    cPProfileImage_image: 'Profilbild',
    cPProfileImage_cancel: 'Abbrechen',
    cPProfileImage_save: 'Speichern',
    textAreaEditInput_check_data: 'Bitte prüfe deine Eingaben',
    textAreaEditInput_missing_data: 'Es fehlt noch deine Angabe, bitte ausfüllen.',
    dateRangeInput_from: 'Von:',
    dateRangeInput_to: 'Bis:',
    errorBox_server_error: 'Es gab ein Problem mit der Verbindung zum Server',
    errorBox_email_exists: 'E-Mail wird bereits verwendet',
    errorBox_email_not_found: 'Wir konnten deine Adresse nicht finden',
    errorBox_email_unknown: 'Diese E-Mail ist uns nicht bekannt',
    errorBox_check_password: 'Bitte prüfe dein Passwort',
    errorBox_email_unknown2: 'Diese E-Mail ist uns unbekannt',
    errorBox_check_data: 'Bitte prüfe deine Eingaben',
    footer_copyright: 'Copyright 2020-2025 - kukundo | All Rights Reserved',
    footer_imprint: 'Impressum',
    footer_agb: 'AGB',
    footer_data_privacy: 'Datenschutzerklärung',
    imageChooserMultiple_image_too_small: 'Bild zu klein',
    imageChooserMultiple_image_too_small_explanation:
        'Das von dir ausgewählte Bild ist zu klein. Es dürfen nur Bilder hochgeladen werden, die mindestens 300 Pixel breit und mindestens 300 Pixel hoch sind.',
    imageChooserMultiple_ok: 'Ok',
    networkOverlay_network_error: 'Netzwerkfehler bei Verbindung zum Server',
    tableBox_no_results: 'Es konnten keine Einträge gefunden werden.',
    tableBoxWithCollapseIcon_no_results: 'Es konnten keine Einträge gefunden werden.',
    tableBoxWithCollapseIcon_name: 'Name',
    tableBoxWithCollapseIcon_address: 'Adresse',
    tableBoxWithCollapseIcon_telephone: 'Telefon',
    tableBoxWithCollapseIcon_email: 'E-Mail',
    adminAccountingDetails_bookings_for: 'Buchungsanfragen für',
    adminAccountingDetails_prev_month: 'Monat zurück',
    adminAccountingDetails_next_month: 'Monat vorwärts',
    adminAccountingDetails_no_invoice: 'Für diesen Monat liegt keine Abrechnung vor.',
    adminAccountingDetails_invoice: 'abrechnen',
    adminAllAccounting_search_course_provider: 'Kursanbieter suchen...',
    adminAllAccounting_invoice_selected: 'Ausgewählte abrechnen',
    adminAllAccounting_invoiced: 'abgerechnet',
    adminAllAccounting_invoice: 'abrechnen',
    adminAllBooking_search_course_provider: 'Kursanbieter suchen...',
    adminAllBooking_search: 'Suchen...',
    adminAllCourseProvider_search: 'Suchen...',
    adminAllCourseProvider_csv_export: 'CSV Export',
    adminAllCourseProvider_really_delete: 'Kursanbieter löschen?',
    adminAllCourseProvider_do_you_want: 'Möchtest du den Kursanbieter',
    adminAllCourseProvider_reallly_delete: 'wirklich löschen?',
    adminAllCourseProvider_not_confirmed: 'nicht bestätigt',
    adminAllCourseProvider_active: 'aktiv',
    adminAllCourseProvider_has_courses: 'hat Kurse',
    adminAllCourseProvider_deleted: 'Gelöscht',
    adminAllCourses_hide_past: 'Abgelaufene Termine ausblenden',
    adminBaseData_delete_entry: 'Eintrag löschen',
    adminBaseData_really_delete: 'Soll der Eintrag wirklich gelöscht werden?',
    adminBaseData_delete: 'Löschen',
    adminBaseData_cancel: 'Abbrechen',
    adminBaseData_save_entry: 'Eintrag speichern',
    adminBaseData_already_exists: 'Eintrag schon vorhanden',
    adminBaseData_ok: 'ok',
    adminDashboard_newest_bookings: 'Neueste Buchungen',
    adminDashboard_newest_registrations: 'Neueste Registrierungen',
    adminDashboard_newest_courses: 'Neueste Kurse',
    cPAllCourses_welcome: 'Herzlich willkommen bei der Web-App von kukundo',
    cPAllCourses_welcome_text1:
        'Mit der kukundo App kannst du dein Anbieterprofil und deine Kurse verwalten sowie deine Buchungsanfragen managen. Ebenso pflegst du hier die Profile der Dozent:innen und deine Veranstaltungsorte.',
    cPAllCourses_please_complete: 'Wir bitten dich, folgende Angaben zu vervollständigen:',
    cPAllCourses_general_info: 'Allgemeine Angaben im Profil',
    cPAllCourses_booking_conditions: 'Buchungsbedingungen im Profil',
    cPAllCourses_lecturers: 'Dozent:innen',
    cPAllCourses_locations: 'Veranstaltungsort',
    cPAllCourses_welcome2: 'Herzlich willkommen bei der Web-App von kukundo!',
    cPAllCourses_welcome2_text1:
        'Mit der kukundo App hast du ab sofort die Möglichkeit, dein Anbieterprofil und deine Kurse vollkommen eigenständig zu verwalten. Wir haben alle deine Daten in die neue Software importiert, damit du nahtlos weiterarbeiten können.',
    cPAllCourses_welcome2_text2:
        'Neu ist, dass du nun auch deine Dozent:innen und Veranstaltungsorte sowie deine Buchungsanfragen komfortabel verwalten kannst.',
    cPAllCourses_welcome2_text3:
        'Wie du weisst, gelten für die Buchungsanfragen über uns deine Buchungsbedingungen. Diese werden wir künftig auf deinem Anbieterprofil anzeigen und bitten dich daher, diese hier zu pflegen:',
    cPAllCourses_your_conditions: 'Deine Buchungsbedingungen',
    cPAllCourses_general_profile: 'Allgemeine Angaben im Profil',
    cPAllCourses_check_bookings1:
        'Für den letzen Monat hast du noch unbestätigte Teilnahmen, bitte prüfe diese. Solltest du diese nicht prüfen, werden wir diese zum',
    cPAllCourses_check_bookings2: 'des Monats automatisch als bestätigt abrechnen.',
    cPAllCourses_to_bookings: 'Zu Buchungsanfrage',
    cPAllCourses_confirm_bookings: 'Teilnahmen bestätigen',
    cPAllCourses_no_courses: 'Du hast noch keine Kurse',
    cPAllCourses_no_courses_for_search: 'Keine Kurse zu der Suche gefunden.',
    cPAllCourses_hide_past_courses: 'Vergangene Kurse ausblenden',
    cPAllCourses_create_new_course: 'Neuen Kurs erstellen',
    cPAllCourses_bookings_exist: 'Buchungen vorhanden',
    cPAllCourses_cannot_delete: 'Dieser Kurs kann nicht gelöscht werden, da er Buchungsanfragen enthält',
    cPAllCourses_ok: 'OK',
    cPAllCourses_cancel: 'Abbrechen',
    cPAllCourses_really_delete: 'Wirklich löschen',
    cPAllCourses_delete_course: 'Kurs löschen',
    cPAllCourses_are_you_sure: 'Bist du sicher, dass dieser Kurs gelöscht werden soll?',
    cPAllLecturers_delete_entry: 'Eintrag löschen',
    cPAllLecturers_confirm_delete: 'Soll der Eintrag wirklich gelöscht werden?',
    cPAllLecturers_delete: 'Löschen',
    cPAllLecturers_cancel: 'Abbrechen',
    cPAllLecturers_cannot_delete: 'Löschen nicht möglich',
    cPAllLecturers_cannot_delete_lecturer:
        'Der ausgewählte Dozent kann nicht entfernt werden, da er noch bei den folgenden Kursen zugewiesen ist:',
    cPAllLecturers_ok: 'Ok',
    cPAllLocations_delete_entry: 'Eintrag löschen',
    cPAllLocations_really_delete: 'Soll der Eintrag wirklich gelöscht werden?',
    cPAllLocations_cancel: 'Abbrechen',
    cPAllLocations_delete: 'Löschen',
    cPAllLocations_cannot_delete: 'Löschen nicht möglich',
    cPAllLocations_cannot_delete_location:
        'Der ausgewählte Ort kann nicht entfernt werden, da er noch bei den folgenden Kursen zugewiesen ist:',
    cPAllLocations_ok: 'Ok',
    cPBookings_still: 'Noch',
    cPBookings_days: 'Tage',
    cPBookings_until_automatic: 'bis zur automatisierten Abrechnung der Vermittlungsgebühr',
    cPBookings_help_text:
        'Für den Vormonat liegen uns folgende Buchungsanfragen/direkte Buchungen vor. Du kannst diese bei Bedarf anpassen. Ergänze unten bitte auch Buchungen, die direkt bei dir mit Hinweis auf kukundo eingegangen und abrechnungsrelevant im Sinne unserer AGB sind. Die automatisierte Rechnungsstellung erfolgt jeweils am 8. des  Monats für den Vormonat auf Basis dieser Aufstellung.',
    cPBookings_bookings_for: 'Buchungsanfragen für',
    cPBookings_month_back: 'Monat zurück',
    cPBookings_month_forward: 'Monat vorwärts',
    cPBookings_show_invoiced: 'Abgerechnete Buchungsanfragen anzeigen',
    cPBookings_open_bookings: 'Offene Buchungsanfragen anzeigen',
    cPBookings_no_invoicing: 'Für diesen Monat liegt keine Abrechnung vor.',
    cPBookings_no_bookings: 'Für diesen Monat liegen keine Buchungsanfragen vor.',
    cPBookings_options:
        'Korrekturmöglichkeiten: Änderung der Buchungsoption, Storno Teilnehmer, Storno Kursanbieter, Teilstorno',
    cPBookings_add_bookings: 'Direkte Buchungen hinzufügen',
    cPBookings_save_error: 'Die Buchung konnte nicht hinzugefügt werden. Ist der Kurs vollständig?',
    cPBookings_cancel_participant: 'Teilnehmer stornieren',
    cPBookings_participant_storno: 'Storno Teilnehmer',
    cPBookings_course_provider_storno: 'Storno Kursanbieter',
    cPBookings_partial_storno: 'Teilstorno',
    cPBookings_partial_storno2: 'Teilstorno:',
    cPBookings_changed_booking_price: 'Angepasste Kursgebühr:',
    cPBookings_cancel: 'Abbrechen',
    cPBookings_save: 'Speichern',
    cPBookings_added_by_course_provider: 'Durch den Kursanbieter hinzugefügt',
    cPCourse_course_details: 'Kursdetails',
    cPCourse_delete_course: 'Kurs löschen',
    cPCourse_course_title: 'Kurstitel',
    cPCourse_course_id: 'KursID/Referenz (optional)',
    cPCourse_description: 'Beschreibung',
    cPCourse_continuous: 'Fortlaufender Kurs',
    cPCourse_on_demand: 'Kurs auf Anfrage',
    cPCourse_self_learn: 'Selbstlernkurs',
    cPCourse_set: 'Kurs mit Terminsets',
    cPCourse_single: 'Kurs mit Einzelterminen',
    cPCourse_duplicate: 'Kurs duplizieren',
    cPCourse_description_help:
        'Bitte gib hier eine aussagefähige Beschreibung deines Kurses / Workshops an. Was ist das Thema? Wie ist der Verlauf des Kurses? Welches Ziel wird verfolgt? Hebe auch gerne die Besonderheiten der räumlichen Gegebenheiten hervor.',
    cPCourse_time_help: 'Mache hier bitte genaue Angaben zu den Kurszeiten pro Kurstag.',
    cPCourse_times: 'Kurszeiten',
    cPCourse_material: 'Material (optional)',
    cPCourse_material_help:
        'Welche Materialien sind für den Kurs erforderlich? Welche Materialien werden gestellt und welche müssen mitgebracht werden? Können Materialien vor Ort käuflich erworben werden? Welche Zusatzkosten sind zu erwarten?',
    cPCourse_accomodation: 'Angaben zur Unterkunft (optional)',
    cPCourse_accomodation_help:
        'Welche Unterkunftsoptionen werden angeboten? Bitte grenze inklusive und optionale Leistungen klar voneinander ab. Hier kannst du Empfehlungen aussprechen, wenn die Teilnehmer sich selbst um ihre Unterkunft kümmern sollen.',
    cPCourse_catering: 'Angaben zur Verpflegung (optional)',
    cPCourse_catering_help:
        'Welche Verpflegungsleistungen (Getränke, Snacks, Mahlzeiten) sind im Preis mit eingeschlossen? Gibt es ausreichend Möglichkeiten, sich vor Ort zu versorgen oder sollten die Teilnehmer ihre Verpflegung mitbringen?',
    cPCourse_lecturer: 'Dozent:in',
    cPCourse_please_choose: 'Bitte wählen',
    cPCourse_lecturer_help:
        'Bitte wähle hier die Dozentin / den Dozenten aus. Sollte die gewünschte Person noch nicht auswählbar sein, dann erfasse diese bitte unter dem Menüpunkt Dozent:innen.',
    cPCourse_location: 'Veranstaltungsort',
    cPCourse_location_help:
        'Bitte wähle hier den Veranstaltungsort aus. Sollte der gewünschte Veranstaltungsort noch nicht auswählbar sein, dann erfasse diesen bitte unter dem Menüpunkt Veranstaltungsorte.',
    cPCourse_video: 'Video URL (optional)',
    cPCourse_keywords: 'Schlagwörter',
    cPCourse_choose_coursetype: 'Bitte Kurstermintyp auswählen:',
    cPCourse_individual: 'Einzelne Termine:',
    cPCourse_individual_help:
        'Wähle diesen Kurstermintyp, wenn jeder angebotene Termin einzeln buchbar ist. Ein Termin kann dabei von halb-, ganz- oder mehrtägiger Dauer sein.',
    cPCourse_continuous2: 'Fortlaufende Termine:',
    cPCourse_continuous_help:
        'Wähle diesen Kurstermintyp, wenn der Kurs regelmäßig (z.B. wöchentlich oder monatlich) an festen Wochentagen und zu festen Zeiten stattfindet. Ein Einstieg in fortlaufende Kurse ist i.d.R. jederzeit möglich.',
    cPCourse_sets: 'Terminsets',
    cPCourse_sets_help:
        'Wähle diesen Kurstermintyp, wenn der Kurs aus zwei oder mehreren separaten Terminen besteht, die nur als Set buchbar sind.',
    cPCourse_on_demand_help:
        'Wähle diesen Kurstermintyp, wenn es keine festen Termine für dieses Kursangebot gibt. Terminwünsche können bei der Buchungsanfrage angegeben werden.',
    cPCourse_self_learn2: 'Selbstlernkurs',
    cPCourse_self_learn_help:
        'Wähle diesen Kurstermintyp, wenn es sich um einen Kurs handelt, der Online/per Streaming nutzbar ist. Dieser Kurs hat keine Termine.',
    cPCourse_choose_type: 'gewählten Kurstermintyp übernehmen',
    cPCourse_type: 'Kurstermintyp',
    cPCourse_offline: 'Offline: Dieser Kurs soll nicht auf kukundo veröffentlicht sein',
    cPCourse_online: 'Online: Dieser Kurs soll auf kukundo veröffentlicht sein',
    cPCourse_link_to_course: 'Link zu diesem Kurs',
    cPCourse_in_publishing:
        'Deine Änderungen werden gerade auf kukundo.de übertragen. Sobald hier ein klickbarer Link erscheint, wurden deine Angaben auf kukundo aktualisiert bzw. veröffentlicht',
    cPCourse_save_now:
        'Wenn du speicherst, werden die Änderungen auf kukundo.de übertragen. Sobald hier danach ein klickbarer Link erscheint, wurden deine Angaben auf kukundo aktualisiert bzw. veröffentlicht',
    cPCourse_could_not_update: 'Der Kurs konnte nicht übermittelt werden. Bitte probiere es später noch einmal.',
    cPCourse_can_save: 'Du kannst den Kurs so wie er ist speichern',
    cPCourse_but_not_publish: 'aber nicht veröffentlichen. Dazu musst du noch folgendes ergänzen:',
    cPCourse_add_title: 'Du musst noch einen Titel vergeben',
    cPCourse_add_description: 'Du musst noch eine Beschreibung vergeben',
    cPCourse_add_video: 'Du musst eine Video URL entweder von YouTube oder Vimeo verwenden',
    cPCourse_course_times: 'Du musst noch die Kurszeiten erklären',
    cPCourse_add_appointments: 'Du musst noch Termine hinzufügen',
    cPCourse_add_option: 'Du musst mindestens eine gültige Buchungsoption hinzufügen',
    cPCourse_add_lecturer: 'Du musst noch eine(n) DozentenIn wählen',
    cPCourse_add_location: 'Du musst noch einen Veranstaltungsort wählen',
    cPCourse_add_category: 'Du musst mindestens eine Kategorie hinzufügen',
    cPCourse_add_level: 'Du musst mindestens ein Level hinzufügen',
    cPCourse_add_technique: 'Du musst mindestens eine Technik hinzufügen',
    cPCourse_add_topic: 'Du musst mindestens ein Themenfeld hinzufügen',
    cPCourse_save: 'Speichern',
    cPCourse_save_and_publish: 'Speichern und veröffentlichen',
    cPCourse_publish: 'Veröffentlichen',
    cPCourse_save_changes: 'Änderungen Speichern',
    cPCourse_confirm_duplicate:
        'Du hast noch nicht gespeicherte Änderungen. Sollen diese gespeichert werden und dann der Kurs dupliziert werden?',
    cPCourse_cancel: 'Abbrechen',
    cPCourse_continue: 'Weiter',
    cPCourse_delete: 'Kurs löschen',
    cPCourse_are_you_sure: 'Bist du sich sicher, dass dieser Kurs gelöscht werden soll?',
    cPCourse_yes_delete: 'Wirklich löschen',
    cPCourse_bookings: 'Buchungen vorhanden',
    cPCourse_cannot_delete: 'Dieser Kurs kann nicht gelöscht werden, da er Buchungsanfragen enthält',
    cPCourse_ok: 'OK',
    cPCourse_new_option: 'Neue Buchungsoption',
    cPCourse_images: 'Bilder',
    cPCourse_start_date: 'Startdatum',
    cPCourse_end_date: 'Enddatum',
    cPCourse_duration: 'Dauer',
    cPCourse_number_seats: 'Anzahl Plätze zur Vermittlung',
    cPCourse_new_appointment: 'Neuer Termin',
    cPCourse_start_time: 'Startuhrzeit',
    cPCourse_end_time: 'Enduhrzeit',
    cPCourse_new_set: 'Neues Terminset',
    cPCourse_appointments: 'Termine',
    cPCourse_number: 'Anzahl',
    cPCourse_pre_seats: 'Vorbelegung Plätze zur Vermittlung:',
    cPCourse_add_appointments2: 'Termine hinzufügen',
    cPProfile_description: 'Beschreibung',
    cPProfile_description_help:
        'Beschreibe bitte hier dein Profil als Kursanbieter:in. Ist dein Plus das breite Angebot oder die Spezialisierung? Welche Standorte bespielst du? Was ist deine Philosophie? Was treibt dich an? Wen möchtest du besonders ansprechen (Zielgruppe)? Seit wann gibt es deine Organisation/Kunstschule bzw. seit wann gibst du Unterricht? Bitte hier keine Vita einstellen! Diese gehört in die Rubrik Dozent:innen.',
    cPProfile_techniques: 'Welche Techniken vermittelst du in deinen Kursen? Mehrfachnennungen sind möglich.',
    cPProfile_categories: 'Welchen Kategorien lassen sich deine Kurse zuordnen. Mehrfachnennungen sind möglich.',
    cPProfile_topics: 'Welche Themenfelder werden in deinen Kursen behandelt? Mehrfachnennungen sind möglich.',
    cPProfile_locked: 'Dein Anbieter-Profil ist aktuell gesperrt.',
    cPProfile_not_complete:
        'Dein Kursanbieter-Profil ist noch nicht vollständig ausgefüllt und noch nicht veröffentlicht. Bitte fülle für die Veröffentlichung noch alle rot gekennzeichneten Felder aus.',
    cPProfile_in_transit:
        'Deine Änderungen werden gerade auf kukundo.de übertragen. Sobald hier ein klickbarer Link erscheint, wurden deine Angaben auf kukundo aktualisiert bzw. veröffentlicht.',
    cPProfile_link_to_profile: 'Link zu deinem Online Profil',
    cPProfile_try_again: 'Dein Profil konnte nicht übermittelt werden. Bitte probiere es später noch einmal.',
    forgotPassword_forgot_password: 'Passwort vergessen?',
    forgotPassword_forgot_help:
        'Du kannst dir hier einen Link an dein E-Mail zusenden lassen, mit dem du ein neues Passwort vergeben kannst.',
    forgotPassword_email: 'E-Mail',
    forgotPassword_send_link: 'Link zusenden',
    forgotPassword_back_to_login: 'Zurück zum Login',
    forgotPasswordResult_sent: 'Passwort Link versendet.',
    forgotPasswordResult_new_password_help:
        'Bitte prüfe deine E-Mails, Du solltest einen Link bekommen haben, mit dem du ein neues Passwort vergeben kannst.',
    forgotPasswordResult_back_to_login: 'Zurück zum Login',
    logIn_email: 'E-Mail',
    logIn_password: 'Passwort',
    logIn_forgot_password: 'Passwort vergessen?',
    logIn_register: 'Registrieren',
    logIn_register_help: 'Du möchtest auch Kunstkurse auf kukundo.de anbieten? Dann registriere dich bitte gerne hier:',
    logout_success: 'Erfolgreich abgemeldet',
    logout_if_you_want: 'Wenn du die kukundo App weiter nutzen möchtest,',
    logout_log_back_in: 'logge dich bitte erneut ein',
    newPassword_new_password: 'Neues Passwort vergben',
    newPassword_choose_new: 'Du kannst nun ein neues Passwort vergeben:',
    newPassword_password: 'Passwort',
    newPassword_again: 'Passwort wiederholen',
    newPassword_save: 'Speichern',
    newPassword_not_same: 'Die Passwörter sind nicht gleich',
    newPasswordFailed_failed: 'Ungültiges Ticket zum Passwort zurücksetzen',
    newPasswordFailed_outdated: 'Dieses Ticket ist nicht mehr gültig.',
    newPasswordFailed_to_login: 'Zum Login',
    newPasswordSuccess_success: 'Neues Passwort gespeichert',
    newPasswordSuccess_saved: 'Dein neues Passwort ist nun gespeichert. Du kannst dich damit jetzt einloggen:',
    newPasswordSuccess_to_login: 'Zum Login',
    registration_course_provider_registration: 'Kursanbieter Registrierung',
    registration_saluation: 'Anrede',
    registration_please_choose: 'Bitte wählen',
    registration_firstname: 'Vorname',
    registration_last_name: 'Nachname',
    registration_name: 'Name Kunstschule/Akademie/Atelier',
    registration_email: 'E-Mail',
    registration_password: 'Passwort',
    registration_again: 'Passwort wiederholen',
    registration_data_privacy: 'Datenschutzerklärung',
    registration_read_and_accepted: 'gelesen und akzeptiere diese.',
    registration_i_have: 'Ich habe die',
    registration_agb: 'AGBs',
    registration_register: 'Registrieren',
    registration_back_to_login: 'Zurück zum Login',
    registration_not_same: 'Die Passwörter sind nicht gleich',
    registrationActivation_activate: 'Registrierung aktivieren',
    registrationActivation_help:
        'Deine Registrierung war erfolgreich. Wir haben dir eine E-Mail mit einem Aktivierungslink gesendet. Bitte öffne diesen Link, um die Registrierung abzuschließen und dein Anbieterprofil zu aktivieren.',
    registrationResult_success: 'Registrierung erfolgreich!',
    registrationResult_login: 'Deine Registrierung war erfolgreich. Du kannst dich nun einloggen:',
    registrationResult_login2: 'Zum Login',
    registrationResult_failed: 'Registrierung konnte nicht aktiviert werden',
    registrationResult_failed_because:
        'Die Aktivierung deiner Registrierung ist fehlgeschlagen. Bitte beachte folgendes:',
    registrationResult_timeout:
        'Der Link aus deiner E-Mail ist nur 72 Stunden gültig und könnte abgelaufen sein. Registriere dich in diesem Fall bitte erneut.',
    registrationResult_only_once:
        'Du kannst den Registrierungslink schon angeklickt haben und bist somit bereits registriert. Du kannst dich in diesem Fall über den Login anmelden.',
    registrationResult_missing_char: 'Du könntest beim Kopieren des Links ein Zeichen vergessen haben.',
    registrationResult_to_registration: 'Zur Registrierung',
};



// WEBPACK FOOTER //
// ./src/TextRes.ts